var map = {
	"./Github_black.png": 717,
	"./Gmail_black.png": 750,
	"./LinkedIn_black.png": 559,
	"./choose-your-weapon-vulcan.png": 913,
	"./close-icon.png": 770,
	"./lizard.png": 127,
	"./paper.png": 617,
	"./rock.png": 553,
	"./scissors.png": 19,
	"./speech-buble.png": 585,
	"./spock.png": 391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 307;